<template>
  <div>
    <!-- 会员卡 -->
    <h4 class="modal_title" v-if="promotes.vip_card_count >0">以下会员卡可用</h4>
    <van-row :gutter="15">
      <van-col :span="col_span" v-for="vip_card in promotes.vip_card">
        <VipCard :vip_card="vip_card" :btn_buy="btn_buy"
                 @buy-vip-card="buy_vip_card(vip_card.uuid)"
                 @show-detail-modal="showDetailModal('vip', vip_card)"></VipCard>
      </van-col>
    </van-row>

    <!-- 优惠券 -->
    <h4 class="modal_title" style="margin-top:20px;" v-if="promotes.coupons_count >0">以下优惠券可用</h4>
    <van-row :gutter="15">
      <van-col :span="col_span" v-for="coupons in promotes.coupons"
               :style="{'display': (coupons.user_limit > 0 && coupons.user_issued >= coupons.user_limit && coupons.user_issued == coupons.user_used) ? 'none' : 'block'}">
        <Coupons :coupons="coupons" :btn_issue="btn_buy"
                 @issue-coupons="issue_coupons(coupons.uuid)"
                 @show-detail-modal="showDetailModal('coupons', coupons)"></Coupons>

      </van-col>
    </van-row>

    <!-- 详情框 -->
    <DiscountDetailModal :title="detailModal.title"
                         v-model:visible="detailModal.visible"
                         :type="detailModal.discountType"
                         :data="detailModal.data"></DiscountDetailModal>
  </div>
</template>

<script>
  import DiscountDetailModal from "components/mobile/settlement/DiscountDetailModal"
  import VipCard from "components/mobile/settlement/VipCard"
  import Coupons from "components/mobile/settlement/Coupons"
  import { listPromotes  } from 'api/settlement/cur_util'
  import { fmtVIPCardInfo } from 'api/settlement/vip_card/admin'
  import { fmtCouponsInfo } from 'api/settlement/coupons/admin'
  import { showMessage, showNotify } from 'api/base/mobile/message'
  import { issueCur } from 'api/settlement/coupons/user'
  import { GetUserState, LoginUser, LogOutUser } from 'api/user/auth/login'
  import { prepareOrder } from 'api/settlement/order/user'
  import {getVipCardInstance, getCouponsInstance} from 'api/settlement/center_card'
  export default {
    components: {
      DiscountDetailModal,
      VipCard,
      Coupons
    },
    props: {
      btn_buy: {
        type: Boolean,
        default: true
      },
      col_span: {
        type: Number,
        default: 24
      },
      cur_uuid: {
          type: String,
          default: null,
      }
    },
    data() {
      return {
        detailModal: {
          visible: false,
          title: '',
          discountType: 'vip',
          data: {}
        },
        promotes: {
            coupons: [],
            coupons_count: 0,
            vip_card: [],
            vip_card_count: 0,
        }
      }
    },

    mounted() {

      this.uuid = this.cur_uuid;

      if (this.$route.params.uuid) {
          this.uuid = this.$route.params.uuid ;
      }


      this.loadCurPromotes()
    },

    methods: {

      loadCurPromotes(){

        const that = this;

        listPromotes(this.uuid).then(result => {

          if (result.succeed) {

            let vip_card_list = [];
            result.vip_card.forEach(item => {
              let filled_vip_card = fmtVIPCardInfo(item);
              vip_card_list.push(filled_vip_card);
            });

            that.promotes.vip_card = vip_card_list;
            that.promotes.vip_card_count = vip_card_list.length;

            let coupons_list = [];
            result.coupons.forEach(item => {
              let filled_coupons = fmtCouponsInfo(item);
              coupons_list.push(filled_coupons);

              console.log(filled_coupons.uuid, filled_coupons.assets_limit, filled_coupons.user_limit,
                filled_coupons.available_num, filled_coupons.user_issued, filled_coupons)
            });

            that.promotes.coupons = coupons_list;
            that.promotes.coupons_count = coupons_list.length;

          } else {
            console.log(`${result.error_msg}`);
          }

        }).catch(err => {
          console.error(err);
        });

      },
      async showDetailModal(type, data) {

        switch (type) {
          case 'vip': {

            let filled_vip = await getVipCardInstance(data.uuid, () => {
//              that.$emit('update:isShowOverlay', true);
            }, () => {
//              that.$emit('update:isShowOverlay', false);
            });
            console.log(`filled_vip: `, filled_vip);

            data = filled_vip;

            console.log(data);

            this.detailModal.discountType = 'vip';
            this.detailModal.title = '会员卡';

            this.detailModal.data = {
              name: data.name,
              desc: data.desc.trim().length === 0 ? '-' : data.desc.trim(),
              discount: data.type === "discount"? data.discount_text + "折": data.discount_text,
              promote_price: data.promote_price,
              origin_price: data.origin_price,
              expired_desc: data.expired_desc,
              rights_tips: data.rights_tips.trim().length === 0 ? '-' : data.rights_tips.trim(),
              receive_tips: data.receive_tips.trim().length === 0 ? '-' : data.receive_tips.trim(),
              instructions: data.instructions.trim().length === 0 ? '-' : data.instructions.trim(),
              cur_scope_detail: data.cur_scope_detail,
              cur_scope: data.cur_scope,
            }

          } break;
          case 'coupons': {

           let filled_coupons_user = await getCouponsInstance(data.uuid, ()=>{
//                that.$emit('update:isShowOverlay', true);
            }, ()=>{
//                that.$emit('update:isShowOverlay', false);
            });

            console.log(`filled_coupons_user: `, filled_coupons_user);

            data = filled_coupons_user;

              this.detailModal.discountType = 'coupons';
              this.detailModal.title = '优惠券';

            this.detailModal.data = {
              name: data.name,
              desc: data.desc.trim().length == 0 ? '-' : data.desc.trim(),
              discount: `${data.discount_strength}${data.discount_text},${data.discount_limit}`,
              expired_desc: data.expired_desc,
              user_limit: data.user_limit,
              rights_tips: data.rights_tips.trim().length == 0 ? '-' : data.rights_tips.trim(),
              receive_tips: data.receive_tips.trim().length == 0 ? '-' : data.receive_tips.trim(),
              instructions: data.instructions.trim().length == 0 ? '-' : data.instructions.trim(),
              cur_scope_detail: data.cur_scope_detail,
              cur_scope: data.cur_scope,
            }

          } break;
        }

        console.log(this.detailModal.data);

        this.detailModal.visible = true;
      },
      async buy_vip_card(vip_card_uuid){

        const that = this;
        await prepareOrder([{
          type: 'vip',
          res_uuid: vip_card_uuid
        }]).then(result => {

          if (result.succeed) {
            that.goPath(`/mobile/order/confirm/${result.confirm_key}`);
          } else {

            switch (result.error_code) {
              case -9999: {
                that.$emit('update:loginVisible', true);
              }
                break;
              default: {
                showNotify(result.error_msg, 'warning')
              }
                break;
            }

          }

        }).catch(err => {

          showNotify(`${err}`, 'warning')

        });

      },
      async issue_coupons(coupons_uuid){
        const that = this;
        let is_logined = false;

        await GetUserState().then(result => {

          if (result.id == undefined) {
              that.$emit('update:loginVisible', true);
          } else {
              is_logined = true;
          }

        }).catch(err => {
           console.log(err);
        });

        if (is_logined){


          issueCur(coupons_uuid).then(result => {

              if (result.succeed){

                this.$notify({
                  title: '领取成功',
                  message: '优惠券已放入卡包~',
                  type: 'success'
                });

                that.loadCurPromotes();

              } else {
                this.$notify({
                  title: '提示',
                  message: result.error_msg,
                  type: 'warning'
                });
              }

          }).catch(err => {
            this.$notify({
              title: '提示',
              message: err,
              type: 'warning'
            });
          });

        }

      },
      goPath(path) {
        this.$router.push(path);
      },


    }
  }
</script>

<style lang="scss" scoped>

</style>
